import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Seo } from "@/components/Seo";
import { BUSINESS } from "@/lib/site";
import { CtaBand } from "@/components/home/CtaBand";

export default function StubPage({ page }) {
  const title = `${page.title} | DMS Home Improvements`;
  return (
    <>
      <Seo title={title} description={page.intro} />
      <section data-testid="stub-page" className="section bg-white">
        <div className="container-site max-w-[820px]">
          <p className="eyebrow">DMS Home Improvements</p>
          <h1 data-testid="page-heading" className="mt-4">
            {page.h1}
          </h1>
          <p className="mt-6 text-lg text-body">{page.intro}</p>
          <p className="mt-4 text-base text-body">Full page content coming soon. In the meantime, get in touch for a free site visit.</p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/contact" data-testid="stub-quote-button" className="btn btn-brand w-full sm:w-auto">
              Get a Free Quote
            </Link>
            <a href={BUSINESS.phoneHref} data-testid="stub-call-button" className="btn btn-outline w-full sm:w-auto">
              <Phone size={18} aria-hidden="true" />
              Call {BUSINESS.founderFirstName} on {BUSINESS.phone}
            </a>
          </div>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
